var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("保险产品信息")))])]), _c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.form,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 18
      },
      rules: _vm.dataRule
    }
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("产品名称"),
      prop: "insuranceId"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("产品名称"),
      allowClear: "",
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.filterOption,
      disabled: _vm.$route.params.id == -1 ? false : true
    },
    on: {
      change: _vm.markChange
    },
    model: {
      value: _vm.form.insuranceId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "insuranceId", $$v);
      },
      expression: "form.insuranceId"
    }
  }, _vm._l(_vm.mainList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("产品标识"),
      prop: "mark"
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.form.mark,
      callback: function ($$v) {
        _vm.$set(_vm.form, "mark", $$v);
      },
      expression: "form.mark"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("承保单位"),
      prop: "unitName"
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.form.unitName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "unitName", $$v);
      },
      expression: "form.unitName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("理赔方式"),
      prop: "type"
    }
  }, [_c("a-checkbox-group", {
    attrs: {
      disabled: _vm.infoEdit ? false : true
    },
    model: {
      value: _vm.form.type,
      callback: function ($$v) {
        _vm.$set(_vm.form, "type", $$v);
      },
      expression: "form.type"
    }
  }, [_c("a-checkbox", {
    attrs: {
      value: "1"
    }
  }, [_vm._v(_vm._s(_vm.$t("后台发起理赔")))]), _c("a-checkbox", {
    attrs: {
      value: "2"
    }
  }, [_vm._v(_vm._s(_vm.$t("客户端发起理赔")))])], 1)], 1)], 1)], 1), _vm.isAuth("home.insuranceClaimsEdit") ? _c("a-row", [_c("a-col", {
    attrs: {
      span: 12
    }
  }), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      "wrapper-col": {
        offset: 18
      }
    }
  }, [_vm.id == -1 || _vm.id != -1 && _vm.infoEdit ? _c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t("保存")))]) : _vm._e(), _vm.id != -1 && !_vm.infoEdit ? _c("a-button", {
    attrs: {
      type: "edit"
    },
    on: {
      click: function ($event) {
        _vm.infoEdit = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("编辑")))]) : _vm._e(), _vm.id != -1 && _vm.infoEdit ? _c("a-button", {
    staticClass: "marginL15",
    on: {
      click: function ($event) {
        _vm.infoEdit = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("取消")))]) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1), _vm.id != -1 ? _c("top-title", {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("配置理赔资料")))])]) : _vm._e(), _vm.id != -1 ? _c("div", [_vm._l(_vm.claimList, function (item, index) {
    return _c("claim-item", {
      key: item.insuranceClaimsId,
      ref: "claimForm",
      refInFor: true,
      attrs: {
        infoObj: item,
        documentList: _vm.documentList,
        claimsList: _vm.claimsList,
        claimsParamList: _vm.claimsParamList,
        insuranceId: _vm.id
      },
      on: {
        classification: _vm.getClaimsResource,
        parameter: _vm.getClaimsParamResource,
        info: _vm.getInfoFun,
        demage: _vm.getDocumentResource
      }
    }, [_c("div", {
      attrs: {
        slot: "btn"
      },
      slot: "btn"
    }, [_vm.isAuth("home.insuranceClaimsEdit") && !item.isEdit ? _c("a-button", {
      staticClass: "marginR15",
      attrs: {
        type: "edit",
        size: "small"
      },
      on: {
        click: function ($event) {
          return _vm.handleEdit(index);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("编辑")))]) : _vm._e(), _vm.isAuth("home.insuranceClaimsDelete") && !item.isEdit ? _c("a-button", {
      attrs: {
        type: "danger",
        size: "small"
      },
      on: {
        click: function ($event) {
          return _vm.handleDelete(item);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("删除")))]) : _vm._e(), _vm.isAuth("home.insuranceClaimsEdit") && item.isEdit ? _c("a-button", {
      attrs: {
        size: "small"
      },
      on: {
        click: function ($event) {
          return _vm.handleCancel(index);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("取消")))]) : _vm._e()], 1)]);
  }), _c("a-form-model", {
    staticClass: "marginT20",
    attrs: {
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 5
      }
    }
  }, [_c("a-form-model-item", {
    staticClass: "searchBox",
    attrs: {
      label: _vm.$t("选择理赔类型")
    }
  }, [_c("a-tree-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      filterTreeNode: _vm.filterTreeOption,
      "show-search": "",
      "dropdown-style": {
        maxHeight: "400px",
        overflow: "auto"
      },
      "tree-data": _vm.typeList,
      placeholder: _vm.$t("请选择") + _vm.$t("理赔类型"),
      "tree-default-expand-all": "",
      "replace-fields": {
        children: "children",
        key: "id",
        value: "id",
        title: "name"
      },
      disabled: _vm.disabled
    },
    on: {
      change: _vm.typeChange
    },
    model: {
      value: _vm.claimsTypeId,
      callback: function ($$v) {
        _vm.claimsTypeId = $$v;
      },
      expression: "claimsTypeId"
    }
  }), _c("a-button", {
    attrs: {
      type: "link",
      disabled: _vm.disabled
    },
    on: {
      click: _vm.addTypeFun
    }
  }, [_vm._v(_vm._s(_vm.$t("新增") + _vm.$t("理赔类型")))])], 1)], 1), _c("type-model", {
    ref: "typeForm",
    on: {
      save: _vm.typeOk
    }
  })], 2) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };